import React, { useRef, useState, useEffect, Fragment } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';

import { component } from 'picoapp';
import { ReactDrawer } from '../../parts';
import CartList from './CartList';

const getCartData = async () => {
  const response = await axios.get('/cart.js', { headers: { Pragma: 'no-cache' } });
  return response.data;
};

const MiniCartButton = ({ handleClick, open, itemCount }) => {
  return (
    <button className="Button Button--minicart" data-layout="noLayout" aria-label="Minicart" onClick={() => handleClick(!open)}>
        <span className="counter">
          <span>{itemCount}</span>
        </span>
    </button>
  );
};

const MiniCart = (props) => {
  const [open, setOpen] = useState(false);
  const [cart, setCart] = useState({ items: [] });
  const [user, setUser] = useState({});
  const refDrawer = useRef(null);

  const updateLineItemQty = async (variant, qty) => {
    await axios
      .post('/cart/update.js', {
        updates: { [variant]: qty },
      })
      .then((response) => {
        setCart(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const API = {
    updateLineItemQty,
  };

  useEffect(() => {
    if(open){
      refDrawer.current.focus();
      document.body.addEventListener('keyup', handleEscape);
    } else {
      document.body.removeEventListener('keyup', handleEscape);
    }
  }, [open])

  // Update the Cart Data on mounting
  useEffect(() => {
    getCartData().then((data) => {
      setCart(data);
    });
  }, []);

  //Close drawer on escape key
  function handleEscape(e) {
    if ( open && e.key === 'Escape'){
      setOpen(false);
    }
  }

  // Update cart and open when adding to cart
  useEffect(() => {
    props.ctx.on('cart.productAdded', () => {
      getCartData().then((data) => {
        setCart(data);
        setOpen(true);
        //document.getElementById('shopify-section-site-header').scrollIntoView();
      });
    });
  }, []);

  const handleClose = (e) => {
    if(e.type == "click"){
      setOpen(false)
    } else if (e.type == 'keyup' && e.key == "Enter"){
      setOpen(false)
    }
  } 

  return (
    <Fragment>
      <MiniCartButton handleClick={setOpen}t open={open} itemCount={cart.item_count}></MiniCartButton>
      <ReactDrawer showDrawer={open} className="Drawer--minicart" setShowDrawer={setOpen} position={'right'}>
        <div className="Minicart__content">
          <header className="Drawer__header">
            <h3 ref={refDrawer} tabIndex="0">IN MY CART</h3>
            <span tabIndex="0" onClick={handleClose} onKeyUp={handleClose}>Close</span>
          </header>
          <CartList cart={cart} products={cart.items} API={API} />
        </div>
      </ReactDrawer>
    </Fragment>
  );
};

export default component((node, ctx) => {
  const element = <MiniCart ctx={ctx} parentNode={node} />;
  ReactDOM.render(element, node);

  // Unmount component on Pjax navigation
  return function () {
    try {
      ReactDOM.unmountComponentAtNode(node);
    } catch (e) {
      console.error(e);
    }
  };
});